export default __webpack_public_path__ + "static/media/tiger.a8dcfd95.jpg";